import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";

import { Location } from "app/common/location";
import { Incident, User } from "app/shared/shared.module";
import { AdminUserService } from "app/adminuser/adminuser.service";
import { Subscription } from "rxjs/Subscription";
import { GUID } from "app/brightserve/brightserve.module";
import { NotificationsService } from "angular2-notifications";
import { SharedCommonService } from "app/shared/shared-common.service";

@Component({
    selector: 'app-adminuser-profile',
    templateUrl: './adminuser-profile.component.html',
    styleUrls: ['./adminuser-profile.component.css']
})
export class AdminUserProfileComponent implements OnInit {

    counto1: any;
    counto2: any;
    counto3: any;

    Step: number = 50;
    Duration: number = 0.5;

    Editable: boolean = false;
    Id: GUID;
    User: User;
    EditUser: User = new User();

    ChangePassword: any = {
        Id: GUID,
        CurrentPassword: "",
        NewPassword: "",
        NewPasswordConfirm: "",
    };

    passwordChangeForm;

    sub: Subscription;
    GetUserDetailsByIdSubscription: Subscription;
    SubmitDetailsChangeSubscription: Subscription;
    ChangePasswordSubscription: Subscription;
    NeedsToSpecifyCurrentPassword: boolean;

    constructor(private adminUserService: AdminUserService, private sharedCommonService: SharedCommonService, private route: ActivatedRoute, private router: Router, private _notification: NotificationsService) { }

    ngOnInit() {
        this.sub = this.route.params.subscribe(params => {
            if (params && params['id']) {
                this.Id = params['id'];
                this.GetUserById(this.Id);
            }
            else
                this.GetCurrentUser();
        }); 
    };

    ngOnDestroy() {
        this.sub.unsubscribe();
        if (this.GetUserDetailsByIdSubscription != null) {
            this.GetUserDetailsByIdSubscription.unsubscribe();
        }
    }

    GetCurrentUser() {
        this.GetUserDetailsByIdSubscription = this.adminUserService.GetCurrentUserDetails().subscribe(user => {
            this.sharedCommonService.GetUserDetails().subscribe((res) => {
                if (this.Id == res.User.Id || (res.User.Privileges & 514))
                    this.Editable = true;
                this.User = user;
                this.EditUser = new User(this.User);
                this.NeedsToSpecifyCurrentPassword = true;
            });
        }, err => {
            this._notification.error("Error Getting Details.", "There was an error getting your details; you must be using an admin account to view user details.");
            this.router.navigateByUrl('/dashboard');
        });
    }
    GetUserById(id) {
        this.GetUserDetailsByIdSubscription = this.adminUserService.GetUserDetailsById(id).subscribe(user => {
            this.sharedCommonService.GetUserDetails().subscribe((res) => {
                if (this.Id == res.User.Id || (res.User.Privileges & 514))
                    this.Editable = true;
                this.User = user;
                this.User.IsClient = user.LogonEntity != null;
                if (this.User.IsDoctor)
                    this.User.UserType = "Doctor";
                else if (this.User.IsClient)
                    this.User.UserType = "Client User";
                else
                    this.User.UserType = "Admin User";
                this.EditUser = new User(this.User);
                this.EditUser.LogonEntity = null;
                this.NeedsToSpecifyCurrentPassword = this.Id == res.User.Id;
            });
        }, err => {
            this._notification.error("Error Getting Details.", "There was an error the details for this doctor, please ensure you are using an admin account.");
            this.router.navigateByUrl('/dashboard');
        });
    }
    SubmitDetailsChange() {
        this.SubmitDetailsChangeSubscription = this.adminUserService.ChangeDetails(this.EditUser).subscribe((res) => {
            this._notification.success("Details Changed", "User details changed successfully.");
            res.IsClient = this.User.IsClient;
            res.IsAdmin = this.User.IsAdmin;
            res.UserType = this.User.UserType;
            this.User = res;
            this.EditUser = new User(this.User);

        }, (err) => {
            if (err && err.status == 400 && err.error && Object.keys(err.error).length) {
                for (var k in err.error) {
                    if (err.error[k] && err.error[k].length) {
                        var text = "";
                        for (var i = 0; i < err.error[k].length; i++) {
                            text += err.error[k][i];
                        }
                        this._notification.error(k.split(".").join(" ") + " Fail", text);
                    }

                }
            } else {
                console.log(err);
                this._notification.error("Detail Change Unsuccessful", "Detail change was unsuccessful, please try again.");
            }
        });
    }

    ResetDetails() {
        this.EditUser = new User(this.User);
    }

    SubmitPasswordChange() {
        this.ChangePassword.Id = this.User.Id;
        this.ChangePasswordSubscription = this.adminUserService.ChangePassword(this.ChangePassword).subscribe((res) => {
            this._notification.success("Password Changed", "Password changed successfully.")
            this.User = res;
            this.EditUser = new User(this.User);
        }, (err) => {
            if (err && err.status == 400 && err.error && Object.keys(err.error).length) {
                for (var k in err.error) {
                    if (err.error[k] && err.error[k].length) {
                        var text = "";
                        for (var i = 0; i < err.error[k].length; i++) {
                            text += err.error[k][i];
                        }
                        this._notification.error(k + " Fail", text);
                    }

                }
            } else {
                console.log(err);
                this._notification.error("Password Change Fail", "Password changed failed.");
            }
        });
    };

    ClearPasswordChange() {
        this.ChangePassword = {
            CurrentPassword: "",
            NewPassword: "",
            NewPasswordConfirm: "",
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/adminuser/profile/adminuser-profile.component.ts